function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { getCurrentDate } from './utils';
export var DATA_TYPES = {
  string: 'String',
  num: 'Number',
  datetime: 'Datetime',
  list: 'List',
  null: 'Null',
  bool: 'Boolean',
  geo: 'Geo'
};
export var AND_OPERATOR = 'AND';
export var ABSTRACT_OPERATORS = {
  is_null: {
    label: 'value is null',
    defaultValue: null,
    rootOperator: 'eq',
    component: 'null-placeholder'
  },
  is_not_null: {
    label: 'value is not null',
    defaultValue: null,
    rootOperator: 'ne',
    component: 'null-placeholder'
  }
};
export var TYPES_CONFIG = {
  Number: _objectSpread({
    eq: {
      label: 'equals',
      defaultValue: 0,
      component: 'input-number'
    },
    ne: {
      label: 'does not equal',
      defaultValue: 0,
      component: 'input-number'
    },
    gt: {
      label: 'is greater than',
      defaultValue: 0,
      component: 'input-number'
    },
    gte: {
      label: 'is greater than or equals',
      defaultValue: 0,
      component: 'input-number'
    },
    lt: {
      label: 'is less than',
      defaultValue: 0,
      component: 'input-number'
    },
    lte: {
      label: 'is less than or equals',
      defaultValue: 0,
      component: 'input-number'
    },
    in: {
      label: 'matches any of the values',
      defaultValue: [],
      component: 'list'
    },
    exists: {
      label: 'property exists',
      defaultValue: true,
      component: 'boolean-switcher'
    }
  }, ABSTRACT_OPERATORS),
  String: _objectSpread({
    contains: {
      label: 'contains',
      defaultValue: '',
      component: 'input-text'
    },
    not_contains: {
      label: 'does not contain',
      defaultValue: '',
      component: 'input-text'
    },
    eq: {
      label: 'is same as ',
      defaultValue: '',
      component: 'input-text'
    },
    ne: {
      label: 'is different than',
      defaultValue: '',
      component: 'input-text'
    },
    in: {
      label: 'matches any of the values',
      defaultValue: [],
      component: 'list'
    },
    exists: {
      label: 'property exists',
      defaultValue: true,
      component: 'boolean-switcher'
    },
    gt: {
      label: 'is greater than',
      defaultValue: '',
      component: 'input-text'
    },
    lt: {
      label: 'is less than',
      defaultValue: '',
      component: 'input-text'
    },
    lte: {
      label: 'is less than or same as',
      defaultValue: '',
      component: 'input-text'
    },
    gte: {
      label: 'is greater than or same as',
      defaultValue: '',
      component: 'input-text'
    },
    regex: {
      label: 'matches regex',
      defaultValue: '',
      component: 'input-text'
    }
  }, ABSTRACT_OPERATORS),
  List: _objectSpread({
    eq: {
      label: 'equals',
      defaultValue: '',
      component: 'input-text'
    },
    ne: {
      label: 'does not equal',
      defaultValue: '',
      component: 'input-text'
    },
    in: {
      label: 'matches any of the values',
      defaultValue: [],
      component: 'list'
    },
    exists: {
      label: 'property exists',
      defaultValue: '',
      component: 'boolean-switcher'
    },
    contains: {
      label: 'contains',
      defaultValue: '',
      component: 'input-text'
    },
    not_contains: {
      label: 'does not contain',
      defaultValue: '',
      component: 'input-text'
    }
  }, ABSTRACT_OPERATORS),
  Boolean: _objectSpread({
    eq: {
      label: 'is',
      defaultValue: true,
      component: 'boolean-switcher'
    },
    ne: {
      label: 'is not',
      defaultValue: true,
      component: 'boolean-switcher'
    },
    exists: {
      label: 'property exists',
      defaultValue: true,
      component: 'boolean-switcher'
    }
  }, ABSTRACT_OPERATORS),
  Datetime: _objectSpread({
    eq: {
      label: 'is specific date',
      defaultValue: getCurrentDate,
      component: 'datepicker'
    },
    ne: {
      label: 'is not specific date',
      defaultValue: getCurrentDate,
      component: 'datepicker'
    },
    gt: {
      label: 'is after',
      defaultValue: getCurrentDate,
      component: 'datepicker'
    },
    gte: {
      label: 'is specific date or after',
      defaultValue: getCurrentDate,
      component: 'datepicker'
    },
    lt: {
      label: 'is before',
      defaultValue: getCurrentDate,
      component: 'datepicker'
    },
    lte: {
      label: 'is specific date or before',
      defaultValue: getCurrentDate,
      component: 'datepicker'
    },
    exists: {
      label: 'property exists',
      defaultValue: true,
      component: 'boolean-switcher'
    }
  }, ABSTRACT_OPERATORS),
  Geo: _objectSpread({
    within: {
      label: 'is within a given radius',
      defaultValue: {
        coordinates: [0, 0],
        maxDistanceMiles: undefined
      },
      component: 'geo-coordinates'
    },
    exists: {
      label: 'property exists',
      defaultValue: true,
      component: 'boolean-switcher'
    }
  }, ABSTRACT_OPERATORS)
};